module.exports = __webpack_public_path__ + "img/icon7.1ebba75b.png";